import React, {useState, useEffect, Children} from 'react';
import './styles/items.css';
import { DamageBar, ItemEmpty } from './UXHelper';
import { ApisProvider, ItemsData } from './feactures/dataProvider';

const urlIPFS = ApisProvider.ipfsProvider;

export const ItemsVertical = ({ id, hasItem }) => {

    const [item, setItem] = useState({
        id: id,
        name: '',
        nation: '',
        power: '',
        rarity: '',
        img: '',
        type: '',
        damage: '',
        templateId: '',


    });
    const [loadingData, setLoadingData] = useState(true);

    const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;

    useEffect(() => {
        loadAsset();

        return () => {
            //
        }
    }, [id])
    

      const loadAsset = async() => {
        if(hasItem === true){
            const response = await fetch(api, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Origin': '*'
                }
            });
            const data = await response.json();
            const assetData = data.data;

            const item_type = assetData.schema.schema_name;
            const item_damage = assetData.mutable_data.Expeditions;
            const item_templateId_target = assetData.template.template_id;
            
            if(item_type === 'weapons'){
                const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(item_templateId_target));
                setItem({
                    id: assetData.asset_id,
                    name: item_data.name,
                    nation: item_data.nation,
                    power: item_data.power,
                    rarity: item_data.rarity,
                    img: item_data.img,
                    type: item_type,
                    damage: item_damage,
                    templateId: item_templateId_target,

                })
                
                setTimeout(setLoadingData, 1000, false);
            }
            else if(item_type === 'suits'){
                const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(item_templateId_target));
                setItem({
                    id: assetData.asset_id,
                    name: item_data.name,
                    nation: item_data.nation,
                    power: item_data.power,
                    rarity: item_data.rarity,
                    img: item_data.img,
                    type: item_type,
                    damage: item_damage,
                    templateId: item_templateId_target,
            
                })
                
                setTimeout(setLoadingData, 1000, false);
            }         
            
        }
        else {
        }
    }
    
    if(!hasItem){
        return(
            <ItemEmpty/>
        )
    }

    if(loadingData){
        return(
            <div className='loading-box edit-loading'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className='visual_item_container'>
                <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                <span className='difuser_visual_item'></span>
            </div>
            <div className='item-info-box2'>
                <DamageBar damage={item.damage} templateid={item.templateId} height={'15px'}/>
            </div>
        </div>
    )
}

export const ItemsHor = ({ itemP, children }) => {

    const [item, setItem] = useState({
        id: itemP.asset_id,
        name: '',
        nation: '',
        power: '',
        rarity: '',
        img: '',
        type: itemP.schema.schema_name,
        damage: itemP.data.Expeditions,
        templateId: '',

    });
    const [loadingData, setLoadingData] = useState(true);

    

    useEffect(() => {
        loadAsset();
    }, [itemP]);

    const loadAsset = () => {
        const templateTarget = itemP.template.template_id;

        if(item.type === 'weapons'){
            const data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
                templateId: templateTarget,
            })
            
            setTimeout(setLoadingData, 500, false);
        }
        else if(item.type === 'suits'){
            const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
                templateId: templateTarget,
            })
            
            setTimeout(setLoadingData, 500, false);
        }

    }

    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    return (
        <div className='item_structurer_container'>
             <div className='titles_container_item'>
                <span className='title_nation_item'>{item.nation}</span>
                <span className='title_name_item'>{item.name}</span>
             </div>
             <div className='visual_item_container'>
                <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                <span className='difuser_visual_item'></span>
                <span className='title_id_item'>#{item.id}</span>
                <span className={`title_rarity_item ${item.rarity.split(" ").join("")}`}>{item.rarity}</span>
             </div>
            <div className='item_info_container_box invt_team_section_info'>
                <div className='item-info-box2 invt_team_section'>
                    <DamageBar damage={item.damage} templateid={item.templateId} height={'15px'}/>
                    {children}
                </div>
                
            </div>
        </div>
    )
}

export const ItemsInv = ({ itemP }) => {
    
    const [loadingData, setLoadingData] = useState(true);
    const [item, setItem] = useState({
        id: itemP.asset_id,
        name: '',
        nation: '',
        power: '',
        rarity: '',
        img: '',
        type: itemP.schema.schema_name,
        damage: itemP.data.Expeditions,
        templateId: '',

    });

    useEffect(() => {
        
        loadAsset();
        
        return () => {
           
          };

    }, [itemP]);

    const loadAsset = () => {
        const templateTarget = itemP.template.template_id;

        if(item.type === 'weapons'){
            const data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
                templateId: templateTarget,
            })
            
            setTimeout(setLoadingData, 500, false);
        }
        else if(item.type === 'suits'){
            const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
                templateId: templateTarget,
            })
            
            setTimeout(setLoadingData, 500, false);
        }

    }

    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }
    
  return (
        <div className='item_structurer_container'>
             <div className='titles_container_item'>
                <span className='title_nation_item'>{item.nation}</span>
                <span className='title_name_item'>{item.name}</span>
             </div>
             <div className='visual_item_container'>
                <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                <span className='difuser_visual_item'></span>
                <span className='title_id_item'>#{item.id}</span>
                <span className={`title_rarity_item ${item.rarity.split(" ").join("")}`}>{item.rarity}</span>
             </div>
            <div className='item_info_container_box'>
                <div className='item-info-box2'>
                    <DamageBar damage={item.damage} templateid={item.templateId} height={'15px'}/>
                </div>
            </div>
        </div>
  )
}

export const RBoxInv = ({ box, onUnbox }) => {

    const [item, setItem] = useState({
        id: '',
        name: '',
        nation: '',
        rarity: '',
        img: '',
        templateId: '',

    });

    const [loadingData, setLoadingData] = useState(true);
    
    useEffect(() => {
        
        loadAsset();

        return () => {
            setItem({});
          };

    }, [box]);

    const loadAsset = async() => {
        setLoadingData(true);
        const templateTarget = box.template.template_id;

        const data = ItemsData.reward_boxes.find(x => Number(x.templateId) === Number(templateTarget));

        setItem({
            id: box.asset_id,
            name: data.name,
            nation: data.nation,
            rarity: data.rarity,
            img: data.img,
            templateId: data.templateId,
        })

        setTimeout(setLoadingData, 500, false);
    }


    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

  return (
            <div className='item_structurer_container'>
                <div className='titles_container_item'>
                    <span className='title_nation_item'>{item.nation}</span>
                    <span className='title_name_item'>{item.name}</span>
                </div>
                <div className='visual_item_container'>
                    <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                    <span className='difuser_visual_item'></span>
                    <span className='title_id_item'>#{item.id}</span>
                    <span className={`title_rarity_item ${item.rarity.split(" ").join("")}`}>{item.rarity}</span>
                </div>
                <div className='item_info_container_box'>
                    <div className='item-info-box2'>
                        <button className='btn-selector-box' onClick={() => {
                            const idchest = item.id;
                            const templateid = item.templateId;
                            onUnbox(idchest, templateid)}}>Unpack</button>
                    </div>
                </div>
            </div>
  )
}

export const RBoxInvBug = ({ id, onUnbox }) => {

    const [item, setItem] = useState({
        id: id,
        name: '',
        nation: '',
        isRewardBox: false,
        rarity: '',
        img: '',

    });

    const [loadingData, setLoadingData] = useState(true);
    
    const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;


    useEffect(() => {
        
        loadAsset();

        return () => {
            setItem({});
          };

    }, [id]);

    const loadAsset = async() => {
        setLoadingData(true);
        const response = await fetch(api, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Origin': '*'
            }
        });
        const data = await response.json();
        const assetData = data.data;
        const templateTarget = assetData.template.template_id;

        if(assetData.schema.schema_name === 'rewardboxes'){
            const itemFound = ItemsData.reward_boxes.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: assetData.asset_id,
                name: itemFound.name,
                nation: itemFound.nation,
                isRewardBox: true,
                rarity: itemFound.rarity,
                templateId: assetData.template.template_id,
                img: itemFound.img,
            })
        }
        else if(assetData.schema.schema_name === 'crates'){
            setItem((state) => ({
                ...state,
                id: assetData.asset_id,
                templateId: assetData.template.template_id,
                isRewardBox: false,
            }))
        }

        setTimeout(setLoadingData, 1000, false);
    }

    if(loadingData){
        return(
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if(item.isRewardBox){
        return (
      
            <div className='item_structurer_container'>
                <div className='titles_container_item'>
                    <span className='title_nation_item'>{item.nation}</span>
                    <span className='title_name_item'>{item.name}</span>
                </div>
                <div className='visual_item_container'>
                    <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                    <span className='difuser_visual_item'></span>
                    <span className='title_id_item'>#{item.id}</span>
                    <span className={`title_rarity_item ${item.rarity.split(" ").join("")}`}>{item.rarity}</span>
                </div>
                <div className='item_info_container_box'>
                    <div className='item-info-box2'>
                        <button className='btn-selector-box' onClick={() => {
                            const idchest = item.id;
                            const templateid = item.templateId;
                            onUnbox(idchest, templateid)}}>Unpack</button>
                    </div>
                </div>
            </div>
        )
    }

  return (
      
            <div className='asset-box card-asset' key={item.id}>
                <div className='item_structurer_container'>
                    <div className='visual_item_container'>
                        <video src={item.img} autoPlay muted loop className='img_item' alt={item.name}/>
                        <span className='difuser_visual_item'></span>
                        <span className='title_id_item'>#{item.id}</span>
                        <span className={`title_rarity_item ${item.name.split(" ").join("")}`}>{item.name}</span>
                    </div>
                    <div className='item_info_container_box'>
                        <div className='item-info-box2'>
                        <button className='btn-selector-box' onClick={() => {
                                const idchest = item.id;
                                const templateIdDouble = item.templateId;
                                onUnbox(idchest, templateIdDouble)}}>Unpack</button>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export const BpItems = ({ id, templateId, onUnbox }) => {

    const [item, setItem] = useState({
        id: id,
        name: '',
        nation: '',
        type: '',
        img: '',

    });

    const [loadingData, setLoadingData] = useState(true);
    
    const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;


    useEffect(() => {
        
        loadAsset();

        return () => {
            setItem({});
          };

    }, [id]);

    const loadAsset = async() => {
        setLoadingData(true);
            const response = await fetch(api, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Origin': '*'
                }
            });
            const data = await response.json();
            const assetData = data.data;
            setItem({
                ...item,
                name: assetData.data.name,
                img: assetData.data.img,
                nation: assetData.data.Nation,
                type: assetData.data.Type,
            })

            setTimeout(setLoadingData, 1000, false);
    }

    if(loadingData){
        return(
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

  return (
            <div className='item_structurer_container'>
                <div className='titles_container_item'>
                    <span className='title_nation_item'>{item.nation}</span>
                    <span className='title_name_item'>{item.name}</span>
                </div>
                <div className='visual_item_container'>
                    <img src={urlIPFS + item.img} className='img_item' alt={item.name}/>
                    <span className='difuser_visual_item'></span>
                    <span className='title_id_item'>#{item.id}</span>
                    <span className={`title_rarity_item ${item.type.split(" ").join("")}`}>{item.type}</span>
                </div>
                <div className='item_info_container_box'>
                    <div className='item-info-box2'>
                        
                    </div>
                </div>
            </div>
  )
}

export const ItemsScrapyard = ({ id, itemtype }) => {

/* CONDICIONALES POR TIPO DE ITEM, ACOMODAR RESPONSIVE DE COMPONENTE DE ITEMS SUPERIORES */
    return (
        <BpItems id={id}/>
    )
}


export const WorkshopItems = ({ itemP, onSelect }) => {

    const [item, setItem] = useState({
        id: itemP.asset_id,
        name: itemP.name,
        nation: '-',
        type: itemP.data.Type,
        img: itemP.data.img,
    });

    const [loadingData, setLoadingData] = useState(true);
    
    useEffect(() => {
        
        /* loadAsset(); */

        return () => {
            setItem({});
          };

    }, []);


    /* const loadAsset = () => {
        const templateTarget = itemP.template.template_id;

        if(item.type === 'weapons'){
            const data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
            })
            
            setTimeout(setLoadingData, 500, false);
        }
        else if(item.type === 'suits'){
            const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));
            setItem({
                id: itemP.asset_id,
                name: data.name,
                nation: data.nation,
                power: data.power,
                rarity: data.rarity,
                img: data.img,
                type: itemP.schema.schema_name,
                damage: itemP.data.Expeditions,
            })
            
            setTimeout(setLoadingData, 500, false);
        }

    } */

    /* if(loadingData){
        return(
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    } */

  return (
            <div className='item_structurer_container_bp'>
                <div className='titles_container_item_bp'>
                    <span className='title_nation_item_bp'>{item.nation}</span>
                    <span className='title_name_item_bp'>{item.name}</span>
                </div>
                <div className='visual_item_container_bp'>
                    <img src={urlIPFS + item.img} className='img_item_bp' alt={item.name}/>
                    <span className='difuser_visual_item_bp'></span>
                    <span className='title_id_item_bp'>#{item.id}</span>
                    <span className={`title_rarity_item_bp ${item.type}`}>{item.type}</span>
                </div>
                <div className='item_info_container_box_bp'>
                    <div className='item-info-box2'>
                        <button className='btn_addPart_bp' onClick={() => {
                            const id = item.id;
                            const part = item.type;
                            const name = item.name;
                            onSelect(id, name, part)
                        }}>Add Part</button>
                    </div>
                </div>
            </div>
  )
}

export const Heroes = ({ itemP, action }) => {

    const [item, setItem] = useState({});
    const [loadingData, setLoadingData] = useState(true);
    
    useEffect(() => {
        
        loadAsset();

        return () => {
            setItem({});
          };

    }, []);


    const loadAsset = () => {
        const templateTarget = itemP.template.template_id;
        const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));

        setItem({
            id: itemP.asset_id,
            name: data.name,
            nation: data.nation,
            power: data.power,
            rarity: data.rarity,
            img: data.img,
            type: itemP.schema.schema_name,
        })
        
        setTimeout(setLoadingData, 500, false);

    }

    if(loadingData){
        return(
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

  return (
            <div className='item_structurer_container_hero'>
                <div className='titles_container_item_hero'>
                    <span className='title_nation_item_hero'>{item.nation}</span>
                    <span className='title_name_item_hero'>{item.name}</span>
                </div>
                <div className='visual_item_container_hero'>
                    <video src={item.img} className='img_item_hero' alt={item.name}/>
                    <span className='difuser_visual_item_hero'></span>
                    <span className='title_id_item_hero'>#{item.id}</span>
                    <span className={`title_rarity_item ${item.rarity.split(" ").join("")}`}>{item.rarity}</span>
                </div>
                <div className='item_info_container_box_hero'>
                    <div className='item-info-box2'>
                        <button className='btn_addPart_hero' onClick={() => {
                            const id = item.id;
                            action(id);
                        }}>Set Hero</button>
                    </div>
                </div>
            </div>
  )
}